import { defineMessages } from 'react-intl';

const messages = defineMessages({
  buttonLabel: { id: 'Text Button', defaultMessage: 'Text Button' },
  buttonLabelDescription: {
    id: 'buttonLabelDescription',
    defaultMessage:
      'For the button to be displayed, it is necessary to fill in your text and link URL.',
  },
  buttonUrl: { id: 'buttonUrl', defaultMessage: 'Button URL' },
  governmentNumbers: {
    id: 'Government Numbers',
    defaultMessage: 'Government Numbers',
  },
  index1: { id: 'index1', defaultMessage: 'First Index' },
  index2: { id: 'index2', defaultMessage: 'Second Index' },
  index3: { id: 'index3', defaultMessage: 'Third Index' },
  index4: { id: 'index4', defaultMessage: 'Fourth Index' },
  indexDescription: { id: 'indexDescription', defaultMessage: 'Description' },
  indexValue: { id: 'indexValue', defaultMessage: 'Value' },
  indexValueDescription: {
    id: 'index1ValueDescription',
    defaultMessage:
      'For the index to be displayed, it is necessary to fill in its value and its description.',
  },
  title: { id: 'Area title', defaultMessage: 'Area title' },
  titleNumbersDescription: {
    id: 'titleNumbersDescription',
    defaultMessage:
      'For the number area to be displayed, it is necessary to fill in its Title or Subtitle and at least two indexes.',
  },
  subtitle: { id: 'Area subtitle', defaultMessage: 'Area subtitle' },
});

export const governmentNumbersSchema = ({ intl }) => {
  return {
    fieldsets: [
      {
        id: 'default',
        title: intl.formatMessage(messages.governmentNumbers),
        fields: ['title', 'subtitle', 'buttonLabel', 'buttonUrl'],
      },
      {
        id: 'index1',
        title: intl.formatMessage(messages.index1),
        fields: ['index1Value', 'index1Description'],
      },
      {
        id: 'index2',
        title: intl.formatMessage(messages.index2),
        fields: ['index2Value', 'index2Description'],
      },
      {
        id: 'index3',
        title: intl.formatMessage(messages.index3),
        fields: ['index3Value', 'index3Description'],
      },
      {
        id: 'index4',
        title: intl.formatMessage(messages.index4),
        fields: ['index4Value', 'index4Description'],
      },
    ],
    properties: {
      title: {
        title: intl.formatMessage(messages.title),
        description: intl.formatMessage(messages.titleNumbersDescription),
      },
      subtitle: { title: intl.formatMessage(messages.subtitle), default: '' },
      buttonLabel: {
        title: intl.formatMessage(messages.buttonLabel),
        description: intl.formatMessage(messages.buttonLabelDescription),
      },
      buttonUrl: {
        title: intl.formatMessage(messages.buttonUrl),
        widget: 'url',
      },
      index1Value: {
        title: intl.formatMessage(messages.indexValue),
        description: intl.formatMessage(messages.indexValueDescription),
      },
      index1Description: {
        title: intl.formatMessage(messages.indexDescription),
      },
      index2Value: {
        title: intl.formatMessage(messages.indexValue),
        description: intl.formatMessage(messages.indexValueDescription),
      },
      index2Description: {
        title: intl.formatMessage(messages.indexDescription),
      },
      index3Value: {
        title: intl.formatMessage(messages.indexValue),
        description: intl.formatMessage(messages.indexValueDescription),
      },
      index3Description: {
        title: intl.formatMessage(messages.indexDescription),
      },
      index4Value: {
        title: intl.formatMessage(messages.indexValue),
        description: intl.formatMessage(messages.indexValueDescription),
      },
      index4Description: {
        title: intl.formatMessage(messages.indexDescription),
      },
    },
    required: [
      'index1Value',
      'index1Description',
      'index2Value',
      'index2Description',
    ],
  };
};
